<template>
  <div id="editSegment" :style="getColorBtn">
    <b-container>
      <b-card id="card-edit" class="mb-3">
        <div class="icon-edit-segment">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="50"
            height="50"
            viewBox="0 0 18 18"
            v-show="!routeAdd"
          >
            <defs>
              <clipPath id="edit-path">
                <path
                  d="M6.672-16a.8.8,0,0,1,.8.8.8.8,0,0,1-.707.795l-.093.005H2.4a.8.8,0,0,0-.795.707L1.6-13.6V-2.4a.8.8,0,0,0,.707.795L2.4-1.6H13.6a.8.8,0,0,0,.795-.707L14.4-2.4V-6.672a.8.8,0,0,1,.8-.8.8.8,0,0,1,.795.707L16-6.672V-2.4A2.4,2.4,0,0,1,13.741,0L13.6,0H2.4A2.4,2.4,0,0,1,0-2.259L0-2.4V-13.6A2.4,2.4,0,0,1,2.259-16L2.4-16Zm6.691-1.762a.812.812,0,0,1,1.149,0h0l3.25,3.25a.812.812,0,0,1,0,1.149h0L9.637-5.238A.812.812,0,0,1,9.063-5H5.813A.813.813,0,0,1,5-5.812H5v-3.25a.812.812,0,0,1,.238-.575h0Zm.575,1.724L6.625-8.726v2.1h2.1l7.313-7.312Z"
                  fill="none"
                  clip-rule="evenodd"
                />
              </clipPath>
            </defs>
            <g transform="translate(0 18)" clip-path="url(#edit-path)">
              <path d="M-5-23H23V5H-5Z" fill="#acadb1" />
            </g>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 30 30"
            v-show="routeAdd"
          >
            <path
              id="Color"
              d="M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z"
              transform="translate(3.75 3.75)"
              fill="#acadb1"
            />
          </svg>
        </div>
        <div v-show="!routeAdd">
          <h4>{{ $t('biblioSegment.editSegment') }}</h4>
          <h6 style="color: #68686b">
            {{ $t('biblioSegment.textEdit') }}
          </h6>
        </div>
        <div v-show="routeAdd">
          <h4>{{ $t('biblioSegment.addSegment') }}</h4>
          <h6 style="color: #68686b">
            {{ $t('biblioSegment.textAdd') }}
          </h6>
        </div>
      </b-card>

      <b-row>
        <b-col>
          <b-form-group
            id="input-group-title"
            :label="$t('biblioSegment.title')"
            label-for="input-title"
          >
            <b-form-input
              id="input-title"
              :placeholder="$t('biblioSegment.placeholder-title')"
              required
              v-model="getTitleSegment"
              :state="stateTitle"
              :maxlength="getmaxLength"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('biblioSegment.theme')" label-for="input-sm">
            <v-select
              :placeholder="$t('biblioSegment.selectTheme')"
              v-model="themeId"
              :options="themeList"
              multiple
            >
              <span slot="no-options">{{ $t('biblioSegment.noOption') }}</span>
              <span slot="no-result">{{ $t('biblioSegment.noResult') }}</span>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-desc"
            :label="$t('biblioSegment.description')"
            label-for="textarea-rows"
          >
            <b-form-textarea
              v-model="description"
              id="textarea-rows"
              :placeholder="$t('biblioSegment.addDescription')"
              rows="4"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('biblioSegment.author')" label-for="input-sm">
            <v-select
              :placeholder="$t('biblioSegment.selectAuthor')"
              v-model="authorId"
              :options="auteursList"
            >
              <span slot="no-options">{{ $t('biblioSegment.noOption') }}</span>
              <span slot="no-result">{{ $t('biblioSegment.noResult') }}</span>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-keyword"
            :label="$t('biblioSegment.Keyword')"
            label-for="input-keyword"
          >
            <v-select
              no-drop
              taggable
              multiple
              :select-on-key-codes="[188, 13]"
              :placeholder="$t('biblioSegment.addkeyword')"
              v-model="keyWords"
            />
          </b-form-group>
        </b-col>
        <b-col> </b-col>
      </b-row>

      <b-row>
        <b-col class="text-right">
          <b-button class="btn-edit" variant="outline-secondary" v-on:click="backToList()">{{
            $t('button.cancel')
          }}</b-button>
          <b-button
            v-show="!routeAdd"
            class="btn-edit"
            variant="primary"
            v-on:click="updateSegment()"
          >
            {{ $t('tooltips.save') }}
          </b-button>
          <b-button v-show="routeAdd" class="btn-edit" variant="primary" v-on:click="NewSegment()">
            {{ $t('button.next') }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import vSelect from 'vue-select';
import mixin from '../../mixins/Mixin.js';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import i18n from '../../i18n';
import fr from '../../i18n/fr_FR';
import en from '../../i18n/en_US';
import 'vue-select/dist/vue-select.css';
export default {
  mixins: [mixin, mixinGrapesHelpers],
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  name: 'EditSegment',
  data() {
    return {
      colorBtn: 'rgb(3,155,229)',

      segmentData: '',
      authorId: '',
      themeId: '',
      title: i18n.t('biblioSegment.placeholder-title'),
      listAuthor: '',
      keyWords: '',
      description: '',
      listSlides: [],
      selectedIds: [],
      keyupEvent: false,
    };
  },
  components: {
    'v-select': vSelect,
  },
  computed: {
    ...mapGetters({
      getmaxLength: 'common/getmaxLength',
      selectedSegments: 'segments/getSelectedSegments',
      currentSegment: 'segments/getCurrent',
      paramsClient: 'getParamsClients',
      hasPermission: 'hasPermission',
      getAuteursList: 'segments/getAuteursList',
      routeAdd: 'segments/getFromRouteAdd',
      getThemesList: 'segments/getThemesList',
      currentSlide: 'slides/getCurrent',
    }),
    getTitleSegment() {
      return this.title;
    },
    stateTitle() {
      var state = this.title.length >= 1 ? true : false;
      if (state) return null;
      else return state;
    },
    themeList() {
      let list = [];

      if (this.getThemesList) {
        this.getThemesList.forEach(t => {
          let o = {};
          o.label = t.name ? t.name : t.title;
          o.code = t.id;
          list.push(o);
        });
      }

      return list;
    },
    auteursList() {
      let list = [];
      if (this.getAuteursList) {
        this.getAuteursList.forEach(t => {
          let o = {};
          o.label = t.name;
          o.code = t.id;
          list.push(o);
        });
      }

      return list;
    },
    getColorBtn() {
      if (this.$route.query.color) {
        this.colorBtn = this.$route.query.color;
      }

      return { '--primary-color': this.colorBtn };
    },
  },
  async mounted() {
    let self = this;
    const urlParams = new URLSearchParams(window.location.color);
    const color = urlParams.get('color') ? urlParams.get('color') : 'rgb(3,155,229)';
    this.colorBtn = color;

    this.setThemes();
    this.getAuteurs();
    if (this.$route.name === 'EditSegment') {
      await this.getSegment(this.$route.params.id);

      //if (!this.routeAdd) {
      this.listAuthor = this.getAuteursList;
      if (this.currentSegment.author) {
        let getName = '';
        if (this.currentSegment.author.firstName) {
          getName =
            this.currentSegment.author.firstName + ' ' + this.currentSegment.author.lastName;
        } else getName = this.currentSegment.author.name;

        let modelAuthor = {};
        modelAuthor.label = getName;
        modelAuthor.code = this.currentSegment.author.id;
        this.authorId = modelAuthor;
      }

      if (this.currentSegment.themes) {
        let modelTheme = [];
        this.currentSegment.themes.forEach(t => {
          var model = {};
          model.label = t.name ? t.name : t.title;
          model.code = t.id;
          modelTheme.push(model);
        });
        this.themeId = modelTheme;
      }
      this.title = this.currentSegment.title;

      if (
        typeof this.currentSegment.keyWords === 'string' ||
        this.currentSegment.keyWords instanceof String
      ) {
        let key = this.currentSegment.keyWords.split(',');
        if (key[0] !== '') this.keyWords = key;
      } else this.keyWords = this.currentSegment.keyWords ? this.currentSegment.keyWords : null;

      this.listSlides = this.currentSegment.screens;
      this.description = this.currentSegment.description;
    } else if (this.$route.name === 'AddSegment') {
      let inputText = document.getElementById('input-title');

      if (inputText) {
        inputText.addEventListener('focus', function(e) {
          if (self.keyupEvent && self.title !== '' && e.event.target !== '') {
            return;
          }
          self.title = '';
        });

        inputText.addEventListener('keyup', function(event) {
          self.title = event.target.value;
          self.keyupEvent = true;
        });
      }
    }
  },

  methods: {
    ...mapActions('common', ['setShowIconSave']),

    ...mapActions('segments', [
      'setCurrentSegment',
      'setCurrentSegmentTitle',
      'updateMetadataSegment',
      'setThemes',
      'getAuteurs',
      'setfromRouteBiblio',
      'getSegment',
    ]),
    ...mapActions('slides', ['setCurrentSlide', 'selectSlide', 'resetSelect', 'updateSlide']),
    backToList() {
      this.$router.push({ name: 'ListSegment' });
      let obj = { ListSegment: true };
      parent.postMessage(obj, '*');
    },
    updateSegment() {
      if (this.title) {
        let themesIdList = [];
        let themesObject = [];
        if (this.themeId) {
          this.themeId.forEach(t => {
            themesIdList.push(t.code);
            let object = this.getThemesList.filter(x => x.id === t.code);
            if (object) themesObject.push(object[0]);
          });
        }
        let key = '';
        if (this.keyWords !== '' && this.keyWords !== null) {
          key = this.keyWords.join();
        }
        this.setCurrentSegmentTitle(this.title);
        this.updateMetadataSegment({
          ...this.currentSegment,
          title: this.title,
          author: this.authorId.code,
          keyWords: key,
          description: this.description,
          themes: themesIdList,
          Objectthemes: themesObject,
          ObjectAuthor: this.getAuteursList.filter(x => x.id === this.authorId.code)[0],
        });

        this.$router.push({ name: 'ListSegment' });
      }
    },
    NewSegment() {
      var iconSave = document.querySelector('.icon-save');
      if (this.title) {
        let themesIdList = [];
        let themesObject = [];
        if (this.themeId) {
          this.themeId.forEach(t => {
            themesIdList.push(t.code);
            let object = this.getThemesList.filter(x => x.id === t.code);
            if (object) themesObject.push(object[0]);
          });
        }
        this.setfromRouteBiblio(true);
        const segment = {
          title: this.title,
          author: this.getAuteursList.filter(x => x.id === this.authorId.code)[0],
          keyWords: this.keyWords,
          description: this.description,
          //uid: Math.floor(new Date().valueOf() * Math.random()),
          themes: themesObject,
        };
        this.resetSelect();
        this.setCurrentSegment(segment);
        this.$router.push({ name: 'segment', params: { type: 'NewSegment' } });
        this.setShowIconSave(true);
        if (iconSave) {
          iconSave.innerHTML =
            "<span style='font-family:RobotoUep!important;'>" +
            this.$t('template.save_and_exit') +
            '</span>';
          iconSave.classList.remove('icon-selected');
        }
      }
      this.updateCanvasDimensions();
    },
  },
};
</script>

<style lang="scss">
#editSegment {
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  margin: 50px;
  padding: 0;
  height: 80%;
  width: 90%;
}
.btn-edit {
  width: 9em;
}

.text-right {
  text-align: right !important;
}
#editSegment .card {
  background-color: #ecedf0;
}
#editSegment .card-body {
  display: flex;
}

#card-edit {
  display: flex;
}
#editSegment .btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}
.icon-edit-segment {
  display: flex;
  margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// EditSegment.vue?c57010b0